import Locale from '@admin/components/locale'
import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import React from 'react'

class Types extends React.Component {

  static propTypes = {
    blocks: PropTypes.array,
    onCancel: PropTypes.func,
    onChoose: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)

  render() {
    const sections = this._getSections()
    return (
      <div className="flowchart-designer-blocks">
        <div className="mjson-designer-content-instructions">
          <T text="Drag and drop any of the elements below into the canvas to build your workflow" />
        </div>
        { sections.map((section, index) => (
          <div className="flowchart-designer-blocks-section" key={`section_${index}`}>
            <div className="flowchart-designer-blocks-section-title">
              <T text={ section.title } />
            </div>
            <div className="flowchart-designer-blocks-section-items">
              { section.blocks.map((block, index) => (
                <div key={`type_${index}`} { ...this._getBlock(block )}>
                  <div className={`flowchart-designer-block-icon ${block.type}`}>
                    <Icon svg={ block.svg } />
                  </div>
                  <div className="flowchart-designer-block-label">
                    <T text={ block.label } />
                  </div>
                </div>
              )) }
            </div>
          </div>
        ))}
      </div>
    )
  }

  _getBlock(block) {
    return {
      className: 'flowchart-designer-block',
      draggable: true,
      onClick: this._handleChoose.bind(this, block),
      onDragStart: this._handleDragStart.bind(this, block)
    }
  }

  _getSections() {
    const { blocks } = this.props
    const sections = [
      { title: 't(Voice)', type: 'voice' },
      { title: 't(SMS)', type: 'sms' },
      { title: 't(Control)', type: 'control' },
      { title: 't(Contact)', type: 'contact' },
      { title: 't(Communication)', type: 'communication' },
      { title: 't(Administrative)', type: 'administrative' }
    ]
    return sections.map(section => ({
      ...section,
      blocks: blocks.filter(block => {
        return block.type === section.type
      })
    })).filter(section => {
      return section.blocks.length > 0
    })
  }

  _handleCancel() {
    this.props.onCancel()
  }

  _handleChoose(block) {
    this.props.onChoose(block)
  }

  _handleDragStart(block, e) {
    e.stopPropagation()
    e.dataTransfer.dropEffect = 'move'
    e.dataTransfer.setData('type', block.type)
    if(block.action) e.dataTransfer.setData('action', block.action)
  }

}

export default Types
